export const generatePerformanceNorms = (req) => {
    const rit = {};
    const ritGoalStart = parseInt(req.url.searchParams.get('ritGoalStart'));
    const ritGoalEnd = parseInt(req.url.searchParams.get('ritGoalEnd'));
    const ritGoalStep = parseInt(req.url.searchParams.get('ritGoalStep'));
    for (let i = ritGoalStart; i <= ritGoalEnd; i = i + ritGoalStep) {
        rit[i] = {
            statusPerc: Math.round(i * 0.33),
        };
    }

    const statusPerc = {};
    const statusPercStart = parseInt(req.url.searchParams.get('statusPercStart'));
    const statusPercEnd = parseInt(req.url.searchParams.get('statusPercEnd'));
    const statusPercStep = parseInt(req.url.searchParams.get('statusPercStep'));
    for (let i = statusPercStart; i <= statusPercEnd; i = i + statusPercStep) {
        statusPerc[i] = {
            rit: i + 160,
        };
    }

    return {
        rit,
        statusPerc,
    };
};

export const generateGrowthNorms = (req) => {
    const rit = {};
    const ritGoalStart = parseInt(req.url.searchParams.get('ritGoalStart'));
    const ritGoalEnd = parseInt(req.url.searchParams.get('ritGoalEnd'));
    const ritGoalStep = parseInt(req.url.searchParams.get('ritGoalStep'));
    for (let i = ritGoalStart; i <= ritGoalEnd; i = i + ritGoalStep) {
        rit[i] = {
            cgp: Math.round(i * 0.28),
            cgi: Math.round(i * 0.3) / 100,
            statusPerc: Math.round(i * 0.33),
        };
    }

    const cgp = {};
    const cgpGoalStart = parseInt(req.url.searchParams.get('cgpGoalStart'));
    const cgpGoalEnd = parseInt(req.url.searchParams.get('cgpGoalEnd'));
    const cgpGoalStep = parseInt(req.url.searchParams.get('cgpGoalStep'));
    for (let i = cgpGoalStart; i <= cgpGoalEnd; i = i + cgpGoalStep) {
        cgp[i] = {
            cgi: -1.3 + Math.round(i * 0.7) / 100,
            rit: i + 180,
            statusPerc: Math.round(i * 1.2),
        };
    }

    const statusPerc = {};
    const statusPercStart = parseInt(req.url.searchParams.get('statusPercStart'));
    const statusPercEnd = parseInt(req.url.searchParams.get('statusPercEnd'));
    const statusPercStep = parseInt(req.url.searchParams.get('statusPercStep'));
    for (let i = statusPercStart; i <= statusPercEnd; i = i + statusPercStep) {
        statusPerc[i] = {
            cgp: Math.round(i * 0.72),
            cgi: Math.round(i * 2.4) / 100,
            rit: i + 160,
        };
    }

    return {
        rit,
        cgp,
        statusPerc,
    };
};
